import { dscvrIcApi } from '@/shared/api';
import { useMutation } from '@tanstack/vue-query';

export const useFollowPortalToggleMutation = () => {
  return useMutation({
    mutationKey: ['follow-portal-toggle-mutation'],
    mutationFn: dscvrIcApi.portal.followPortalToggle,
  });
};
